<footer>
  <div class="container">
    <!-- Logo -->
    <div class="row">
      <div class="col-12 py-3 text-center align-content-center logo">
        <a routerLink="/home">
          <img src="assets/img/logos_cinemateca/SVG/logo_completo_blanco.svg" class="logo" alt="Cinemateca Uruguaya" />
        </a>
      </div>
    </div>

    <!-- Menu horizontal -->
    <div class="row justify-content-center">
      <div class="col-12 px-1">
        <ul class="list-group list-group-horizontal justify-content-center">
          <li class="list-group-item bg-transparent border-0 p-0 px-2 text-center">
            <a routerLink="/home"> Inicio</a>
          </li>

          <li class="list-group-item bg-transparent border-0 p-0 px-2 text-center">
            <a href="#"> Acerca</a>
          </li>

          <li class="list-group-item bg-transparent border-0 p-0 px-2 text-center">
            <a href="/faq"> Preguntas frecuentes</a>
          </li>

          <li class="list-group-item bg-transparent border-0 p-0 px-2 text-center">
            <a routerLink="/contact"> Contacto</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Social -->
    <div class="row social">
      <div class="col-12 mb-5">
        <ul class="list-group list-group-horizontal justify-content-center">
          <li class="list-group-item bg-transparent border-0">
            <a href="https://www.facebook.com/cinematecauruguaya/"> <i class="fab fa-facebook-square"></i></a>
          </li>

          <li class="list-group-item bg-transparent border-0">
            <a href="https://twitter.com/cinematecauru"> <i class="fab fa-twitter"></i></a>
          </li>

          <li class="list-group-item bg-transparent border-0">
            <a href="https://www.instagram.com/cinematecauruguaya/"> <i class="fab fa-instagram"></i></a>
          </li>

          <li class="list-group-item bg-transparent border-0">
            <a href="https://www.youtube.com/channel/UCm8aX_aNUiBPYDpHA49wulg"> <i class="fab fa-youtube"></i></a>
          </li>

          <li class="list-group-item bg-transparent border-0 pt-3">
            <a href="https://cinemateca.org.uy/"> <strong>www</strong></a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Direccion y telefono -->
    <div class="row justify-content-center">
      <!-- Mobile -->
      <div class="col-12 col-lg-7 mb-4 text-center text-lg-left d-lg-none">
        <a href="https://goo.gl/maps/sYzHucajun7XeF5GA"><i class="fas fa-map-marker-alt mr-2"></i> Bartolomé Mitre 1236,
          Montevideo, Uruguay</a>
      </div>
      <div class="col-12 col-lg-4 mb-4 text-center text-lg-right d-lg-none">
        <a href="tel:+59829147569s"><i class="fas fa-phone-volume mr-2"></i> (+598) 2914 75 69</a>
      </div>

      <!-- Desktop -->
      <div class="col-12 mb-4 text-center d-none d-lg-inline">
        <a href="https://goo.gl/maps/sYzHucajun7XeF5GA" class="mx-3"><i class="fas fa-map-marker-alt mr-2"></i>
          Bartolomé Mitre 1236, Montevideo, Uruguay</a>
        <a href="tel:+59829147569s" class="mx-3"><i class="fas fa-phone-volume mr-2"></i> (+598) 2914 75 69</a>
      </div>
    </div>
  </div>

  <!-- Sponsors -->
  <div class="container-fluid">
    <div class="line op-03"></div>

    <div class="row sponsors">
      <!-- Mobile -->
      <div class="col-12 mb-2 text-center d-lg-none">
        <div class="mx-4 d-inline-block op-03">
          <div class="mt-2 d-inline-block">
            <img style="height: 40px" class="ml-4 mr-2 mb-3" src="../assets/img/logotipos/FederalForeignOffice.png"
              alt="" />
            <img style="height: 40px" class="mr-4 ml-2 mb-3" src="../assets/img/logotipos/GOETHE_INSTITUT.png" alt="" />
          </div>
        </div>

        <div class="mx-4 mt-4 d-inline-block op-03">
          <div class="mt-2 d-inline-block">
            <img style="height: 40px" class="ml-4 mr-2 mb-3" src="../assets/img/logotipos/RobertBoschStiftung.png"
              alt="" />
            <img style="height: 20px" class="mr-4 ml-2 mb-3" src="../assets/img/logotipos/SFISCHER_STIFTUNG.png"
              alt="" />
          </div>
        </div>

        <div class="mx-4 d-inline-block text-center subsidio">
          <div class="mt-2 d-inline-block">
            <p class="p-2">
              <strong class="op-03">El desarrollo de este proyecto ha sido subsidiado con recursos del Fondo
                Internacional de Asistencia del Ministerio de
                Relaciones Exteriores de la República Federal de Alemania, del Goethe-Institut y otros socios:
              </strong>
              <a class="text-white" href="https://www.goethe.de/hilfsfonds" target="_blank">www.goethe.de/hilfsfonds</a>
            </p>
          </div>
        </div>
      </div>

      <!-- Desktop -->
      <div class="col-12 mb-2 text-center d-none d-lg-flex justify-content-center align-items-center">
        <div class="mx-4 d-inline-block text-left op-03">
          <div class="mt-2 d-inline-block">
            <img style="height: 40px" class="mx-4 mb-3" src="../assets/img/logotipos/FederalForeignOffice.png" alt="" />
            <img style="height: 40px" class="mx-4 mb-3" src="../assets/img/logotipos/GOETHE_INSTITUT.png" alt="" />
          </div>
        </div>

        <div class="mx-4 d-inline-block text-left op-03">
          <div class="mt-2 d-inline-block">
            <img style="height: 40px" class="mx-4 mb-3" src="../assets/img/logotipos/RobertBoschStiftung.png" alt="" />
            <img style="height: 40px" class="mx-4 mb-3" src="../assets/img/logotipos/SFISCHER_STIFTUNG.png" alt="" />
          </div>
        </div>

        <div class="mx-4 d-inline-block text-left subsidio">
          <div class="d-inline-block">
            <p class="px-2 m-0 Mw_200px">
              <strong class="op-03">El desarrollo de este proyecto ha sido subsidiado con recursos del Fondo
                Internacional de Asistencia del Ministerio de
                Relaciones Exteriores de la República Federal de Alemania, del Goethe-Institut y otros socios:
              </strong>
              <a class="text-white" href="https://www.goethe.de/hilfsfonds" target="_blank">www.goethe.de/hilfsfonds</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Copyright -->
  <!-- <div class="container-fluid mt-4">
    <div class="row copyright">
      <div class="col-12 p-2">
        <span class="text-white op-03 font-weight-bold"> <i class="far fa-copyright mr-1"></i> Todos los derechos reservados | </span> <a
          href="https://fx2.com.uy/">
          Fx2</a>
      </div>
    </div>
  </div> -->
</footer>